import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {AppComponent} from '../app.component';
import {SessionService} from '../Services/Session/session-service.service';
import {Router, RouterLink} from '@angular/router';
import {environment} from '../../environments/environment';
import {any} from 'codelyzer/util/function';
import {ApiService} from '../Services/Api/api.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../assets/layout/style/layout.css'],
  providers: [MessageService]
})
export class HomeComponent implements OnInit, AfterViewChecked {
  constructor(public app: AppComponent, private realm: RealmService,
              private session: SessionService, private router: Router, private cdRef: ChangeDetectorRef,
              private api: ApiService, private messageService: MessageService,
              private firebase: FirebaseService) {}
  menuHome: any[] = [];
  menu: any[] = [];
  items: MenuItem[] = [];
  items2: any[] = [];
  profiledata = [];
  titlepage: string;
  titleMenu: string;
  env = environment;
  itemsStep: MenuItem[];
  loaderShow: boolean;
  loadingProvidersDownload: boolean = false;
  counterDownloadProviders: number = 0;
  user: any;
  ngOnInit() {
    this.session.saveParam('selectedProvider', '');
    this.session.saveParam('showSteps', 'false');
    this.env.selectedProvider = null;
    this.env.showSteps = false;
    this.router.navigate(['home/content']);
    navigator.geolocation.getCurrentPosition(function(position) {
      
    });
    this.session.getData('user').then(data => {
      this.user = data
      this.env.policyHolderCardNumberOld = this.user.policyHolderCompleteCardNumberOld;
      this.env.currentPolicy = this.user.policy
      console.log('set data policy ',this.env.policyHolderCardNumberOld)
      console.log('set data policy ',this.env.currentPolicy)
    });

    this.firebase.fetchActivate().then(() => {
      console.log("conexion exitosa");
      this.getPoliciesCMI();
    }).catch(() => {
      console.log("error en conexion ");
    });
    console.log('set data policy cmi ',this.env.policiesExclude)

    this.realm.setProviders$.subscribe( (data: any) => {
      console.log("subscribe setProviders: data providers");
      // @ts-ignore
      if (data !== null) {
        if (this.env.loadingProviders) {
          if (data.code != undefined) {
            if (data.code == 504) {
              this.messageService.clear();
              console.log("imprimir msg 504");
              this.counterDownloadProviders++;
              if (this.counterDownloadProviders < 2) {
                this.messageService.add({severity: 'info', summary: 'Aviso', detail: 'Upps.. tal parece que se esta tardando mas de lo usual, se reintentará automáticamente la descarga.', sticky: false});
                this.realm.getSetProviders();
              } else {
                this.messageService.add({severity: 'error', summary: 'Error', detail: 'Error en la descarga, existen problemas en la conexión.', sticky: false});
              }
            }
          } else {
            console.log("entra else 49");
            this.env.loadingProviders = false;
            this.messageService.clear();
            console.log("imprimir msg exito");
            this.messageService.add({severity: 'info', summary: 'Aviso', detail: 'Los proveedores se encuentran actualizados.', sticky: false});
          } 
        } 
      } 
    });

    this.api.responseApiRenovation$.subscribe((value: any) => {
      console.log('Renovationresponse', value);
    });
    
    this.profiledata.push({name: this.session.getvvalueSession('data', 'policyHolderCompleteName')});
    

    this.realm.getMenuHome().then((value:any) => {
      if (value !== undefined) {
        console.log('MENUS', value);
        console.log('policy card ',this.env.policyHolderCardNumberOld)
        console.log('policy card ',this.env.policiesExclude)
        console.log('policy card ',this.env.currentPolicy)
        console.log('policy card ',this.env.policiesExclude.includes(this.env.currentPolicy))
        let showCMI = this.env.policiesExclude.includes(this.env.currentPolicy)
        
        // @ts-ignore
        this.menuHome = value;
        this.items2 = [];
        this.menuHome.forEach(valu => {
          if (valu.Title !== '') {
            let q = valu.Title;
            let q2 = valu.subTitleRc;
            if (q === '' || q == null) { q = valu.Title; }
            if (q2 === '' || q2 == null) { q2 = valu.subTitleRc; }
            const qs = {title: q, subtitle: q2, storyId: valu.storyboardId, image: valu.icon};
            console.log("titulo: ", q);
            if (q == 'Gestione su reclamo') {
              console.log("entra a reclamos");
              let qs:any;
              if (showCMI) {
                console.log('MOSTRAR RECLAMO CMI');
                qs = {title: 'Gestione su reclamo', subtitle: q2, storyId: 'new-claim', image: valu.icon};
              } else {
                qs = {title: 'Gestione su reclamo', subtitle: q2, storyId: valu.storyboardId, image: valu.icon};
              }
              if (this.env.usrGTM) {
                console.log("es usuario GTM");
                this.items2.push(qs);
              }
            } else if (q == 'Reclamos') {
              console.log("entra a reclamos");
              let qs:any;
              if (showCMI) {
                console.log('MOSTRAR RECLAMO CMI');
                qs = {title: 'Ver reclamos', subtitle: q2, storyId: 'claims', image: valu.icon};
                this.items2.push(qs);
              } 
            } else if (q == 'Renovaciones') {
              console.log("entra a renovaciones");
              if (this.env.usrGTM) {
                console.log("es usuario GTM");
                this.items2.push(qs);
              }
            } else if (q == 'Emergencia') {
              console.log("entra a Emergencia");
              if (this.env.usrHN || showCMI) {
                console.log("es usuario HN o CMI");
              } else {
                console.log("NO se excluye teléfonos importantes");
                this.items2.push(qs);
              }
            } else if (q == 'Contacto') {
              console.log("entra a contactos");
              if (showCMI == false) {
                console.log("se excluye contacto");
              } else {
                console.log("NO se excluye contacto");
                this.items2.push(qs);
              }
            } else if (q == 'Teléfonos importantes') {
              console.log("entra a Teléfonos importantes");
              if (showCMI == false) {
                console.log("se excluye teléfonos importantes");
              } else {
                if (this.env.usrHN) {
                  console.log("es usuario HN");
                } else {
                  console.log("NO se excluye teléfonos importantes");
                  this.items2.push(qs);
                }
              }
            } else {
              this.items2.push(qs);
            }
          }
        });
      }
    })
    
    this.itemsStep = [{
      label: 'Copago',
      command: (event: any) => {
        this.env.activeIndex = 0;
      },
      routerLink: 'checkout'
    },
      {
        label: 'Pago',
        command: (event: any) => {
          this.env.activeIndex = 1;
        },
        routerLink: 'payment'
      },
      {
        label: 'Confirmación',
        command: (event: any) => {
          this.env.activeIndex = 2;
        },
        routerLink: 'confirmation'
      },
      {
        label: 'Lista de Espera',
        command: (event: any) => {
          this.env.activeIndex = 3;
        },
        routerLink: 'wait'
      }
    ];
  }

  ngAfterViewInit() {
    console.log("--------- ngAfterViewInit ----------");
    const q = this.session.getParam('providers');
    console.log("loadingProvidrs: ", this.env.loadingProviders);
    if (q == '' || q === null) {
       console.log("entra a loadproviders true 42");
       //this.env.loadingProviders = true;
       //this.loadingProvidersDownload = true;
       this.messageService.clear();
       console.log("imprimir msg descargando");
       //this.messageService.add({severity: 'info', summary: 'Información', detail: 'Se están descargando los proveedores, por favor espere a que termine la carga inicial.', sticky: false});
       //this.realm.getSetProviders();
   }
   this.realm.getRenovationSettings();
   
  }

  close() {
    this.realm.postSessionSettings().then(() => {
      window.sessionStorage.clear();
    }) ;
    if (this.env.policyHolderCardNumberOld.indexOf('U') > -1) {
      this.router.navigate(['cmi']);
    } else {
      this.router.navigate(['']);
    }
    
  }

  newWindow(url: string) {
    window.open(url, '_blank');
    this.env.showSteps = false;
  }

  async getPoliciesCMI() {
    this.env.policiesExclude = await this.firebase.getStringRC('cmi_policy_list');
  }

 async changetitle(page: string, url: string) {
     this.titlepage = page;
     this.env.showSteps = false;
     console.log('menuoption', url);
     const q = await this.session.getParam('providers');
    if (!this.env.loadingProviders && url === 'providers' && q === null) {
      console.log("entra a loadproviders true");
      this.env.loadingProviders = true;
      this.realm.getSetProviders();
      this.messageService.add({severity: 'info', summary: 'Información', detail: 'Se estan descargando los proveedores, por favor espere a que termine la carga inicial.', sticky: false});
      this.router.navigate(['home/' + url]);
    } else if (url === 'providers' && this.env.loadingProviders) {
      this.messageService.clear();
      console.log("imprimir msg descargando autorizaciones");
      this.messageService.add({severity: 'info', summary: 'Información', detail: 'Por favor espera mientras se descargan los proveedores.', sticky: false});
    } else if (url === 'authorization' && this.env.loadingAuthorizations) {
      this.messageService.clear();
      console.log("imprimir msg descargando autorizaciones");
      this.messageService.add({severity: 'info', summary: 'Información', detail: 'Por favor espera mientras se valida última autorización.', sticky: false});
    } else {
      this.router.navigate(['home/' + url]);
    }
 }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
}
